import Typography from '@alltrails/core/components/Typography';
import type { PageUICommunityInsightSection } from '../../../utils/PageUI/pageUI';
import PageUIReviewQuote from '../PageUIReviewQuote/PageUIReviewQuote';
import styles from './PageUICommunityInsight.module.scss';

type Props = {
  section: PageUICommunityInsightSection;
};

/**
 * A quote from a member's review, titled as a community insight.
 */
export default function PageUICommunityInsight({ section }: Props) {
  const title = 'Community insight'; // hwandrew TODO: XPLR-204 translations

  return (
    <div className={styles.insight}>
      <Typography component="span" variant="text100bold">
        {title}
      </Typography>
      <PageUIReviewQuote reviewHighlight={section.reviewHighlight} />
    </div>
  );
}
